<template>
    <div>
        <div class="p-grid">
            <div class="p-col-12">
                <div class="card">
                    <div class="row col-12 col-4 font-12">
                        <div class="col-9">
                            <h4>Реєстр КП</h4>
                        </div>
                        <div class="col-3">
                            <div class="form-group">
                                <select class="form-control font-12" v-on:change="loadLazyData()" v-model="filter.type">
                                    <option selected :value="''">Всі конфігуратори</option>
                                    <option value="PlavniSpuskyService">Плавні пуски</option>
                                    <option value="Krm">КРМ</option>
                                    <option value="Ya5000Service">я5000</option>
                                    <option value="AvrService">АВР</option>
                                    <option value="KlemnyiRiadService">Клемні ряди</option>
                                    <option value="Sho90Service">Що90</option>
                                    <option value="Sho125Service">Що125</option>
                                    <option value="KalkulyatorShini">Підбір шини</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-col-12">
                <div class="card mt-1">
                    <DataTable
                        ref="dt"
                        dataKey="id"
                        :value="datatable.data"
                        :loading="datatable.loading"
                        rowGroupMode="rowspan"
                        :groupRowsBy="['name','id']"
                        v-model:selection="selectedItems"
                        @rowReorder="onRowReorder"
                        style="font-size: 12px; overflow-x: auto"
                    >
                        <template #header>
                            <div style="text-align: left">
                                <Button label="Видалити обрані" icon="pi pi-trash" class="btn btn-danger mr-1" severity="danger" @click="confirmDeleteSelected" v-if="selectedItems && selectedItems.length" />
                                <a :href="route('api.offer.export', {type: filter.type ? filter.type : 'all'})">
                                    <Button icon="pi pi-external-link" label="Скачати в Excel" />
                                </a>
                            </div>
                        </template>
                        <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
                        <Column field="id" :rowReorder="true" :reorderableColumn="false" header="">
                            <template #body="slotProps">
                                <div class="table-actions">
                                    <delete-confirmation
                                        :route-path="route('api.offer.delete', {offer: slotProps.data.id})"
                                        :redirect-path="route('commercial-offers')"
                                        :title="'Удаление'"
                                        class="p-button-danger"
                                    />
                                </div>
                            </template>
                        </Column>
                        <Column field="id" header="#">
                            <template #body="slotProps">
                                {{
                                    slotProps.data.uuid ? slotProps.data.uuid : slotProps.data.id
                                }}
                            </template>
                        </Column>
                        <Column field="created_at" header="Дата запиту">
                            <template #body="slotProps">
                                {{
                                    moment(slotProps.data.created_at).format("DD.MM.YYYY")
                                }}
                            </template>
                        </Column>
                        <Column field="total_price" header="Сумма специфікації, грн. без ПДВ">
                            <template #body="slotProps">
                                {{
                                    slotProps.data.total_price ? slotProps.data.total_price : '-'
                                }}
                            </template>
                        </Column>
                        <Column field="specification_link" header="Посилання на специфікацію xlsx">
                            <template #body="slotProps">
                                <a :href="slotProps.data.specification_link" target="_blank">{{ slotProps.data.specification_link }}</a>
                            </template>
                        </Column>
                        <Column field="organization" header="Найменування організації">
                            <template #body="slotProps">
                                {{
                                    slotProps.data.organization ? slotProps.data.organization : '-'
                                }}
                            </template>
                        </Column>
                        <Column field="" header="Контактна особа">
                            <template #body="slotProps">
                                {{
                                    slotProps.data.name ? slotProps.data.name : '-'
                                }}
                            </template>
                        </Column>
                        <Column field="phone" header="Номер телефону">
                            <template #body="slotProps">
                                <a style="white-space: nowrap;">{{
                                    slotProps.data.phone ? slotProps.data.phone : '-'
                                }}</a>
                            </template>
                        </Column>
                        <Column field="email" header="Електрона адреса">
                            <template #body="slotProps">
                                {{
                                    slotProps.data.email ? slotProps.data.email : '-'
                                }}
                            </template>
                        </Column>
                        <Column field="status" header="Коментарі до заявки">
                            <template #body="slotProps">
                                {{
                                    slotProps.data.comment ? slotProps.data.comment : '-'
                                }}
                            </template>
                        </Column>
                        <Column field="status" header="Найменування конфігуратора">
                            <template #body="slotProps">
                                {{
                                    getEntityName(slotProps.data.type ? slotProps.data.type : '-')
                                }}
                            </template>
                        </Column>
                        <template #footer>
                            Всього {{ total_summ }}
                        </template>
                    </DataTable>
                    <pagination v-model="filter.page" :records="total" :per-page="20" @paginate="loadLazyData()"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import Menubar from "primevue/menubar";
import Column from "primevue/column";
import Row from "primevue/row";
import ColumnGroup from "primevue/columngroup";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import AutoComplete from "primevue/autocomplete";
import CalculatorService from "../Services/CalculatorService";
import axios from "axios";
import DeleteConfirmation from '../mixins/components/delete.vue';
import Pagination from 'v-pagination-3';
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "moment";
import swal from 'sweetalert2';

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        DataTable,
        Column,
        Row,
        ColumnGroup,
        Button,
        InputText,
        InputNumber,
        AutoComplete,
        DeleteConfirmation,
        Pagination,
        swal,
    },
    data() {
        return {
            moment: moment,
            total: 0,
            total_summ: 0,
            filter: {
                page: 1,
                search: null,
                status: null,
                type: '',
                by: 'id',
                dir: 'desc',
            },
            filteredCompetitorArticles: null,
            selectedCompetitorArticle: [],
            tableDiscount: {},
            tableCount: {},
            defaultPercent: 0,
            defaultCount: 1,
            buyer: null,
            datatable: {
                loading: false,
                data: [],
                lazyParams: {}
            },
            virtualTableData: [],
            selectedModel: null,
            deleteDialog: false,
            deletingModel: false,
            selectedTableRow: null,
            emptyRowIndex: 0,
            focused: {},
            buyerReadonly: false,
            competitorIds: [],
            competitorArticleNameEdit: {},
            selectedItems: [],
        }
    },
    calculatorService: null,
    created() {
        this.calculatorService = new CalculatorService();
    },
    mounted() {
        this.loadLazyData();
    },
    methods: {
        loadLazyData() {
            if (this.filter.search) {
                this.filter.page = 1;
            }
            
            this.datatable.lazyParams = {
                search: this.competitorIds,
            };
            this.datatable.loading = true;
            this.datatable.lazyParams['buyer'] = this.buyer;
            this.calculatorService.getData(this.route('api.offer.list', this.filter), this.datatable.lazyParams).then(data => {
                this.total = data.items.total;
                this.total_summ = data.total;
                this.datatable.data = data.items.data.concat(this.virtualTableData);

                this.defineDefaultData();

                this.datatable.loading = false;

                window.scroll(0, 0);
            });
        },
        confirmDeleteSelected() {
            new swal({
                title: 'Ви впевнені?',
                text: 'Замовлення будуть повністю видалені із системи',
                icon: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                buttons: ['Скасувати', 'Підтвердити'],
            }).then((result) => {
                if (!result.isConfirmed) {
                    return
                }

                let ids = [];

                this.selectedItems.forEach((value, index) => {
                    if (value.id) {
                        ids.push(value.id)
                    }
                });

                axios.post(this.route('api.offer.delete_many'), {ids: ids})
                    .then(({data: {message}}) => {
                        this.loadLazyData()
                    })
                    .catch((response) => {
                        console.log(response);
                    });

            });
        },
        defineDefaultData() {
            this.datatable.data.forEach(function (data, index) {
                if (!data.id) {
                    return;
                }
                if (typeof this.tableDiscount[data.id] === "undefined") {
                    this.tableDiscount[data.id] = this.defaultPercent;
                }
                if (typeof this.tableCount[data.id] === "undefined") {
                    this.tableCount[data.id] = this.defaultCount;
                }
            }, this);
        },
        getEntityName(code) {
            if (code === 'PlavniSpuskyService') {
                return 'Плавні пуски';
            } else if (code === 'Krm') {
                return 'КРМ';
            } else if (code === 'Ya5000Service') {
                return 'я5000';
            } else if (code === 'AvrService') {
                return 'АВР';
            } else if (code === 'KlemnyiRiadService') {
                return 'Клемні ряди';
            } else if (code === 'Sho125Service') {
                return 'ЩО125';
            } else if (code === 'Sho90Service') {
                return 'ЩО90';
            } else if (code === 'KalkulyatorShini') {
                return 'Підбір шини';
            }
        },
        onRowReorder(event) {
            if (event.dragIndex === event.dropIndex) {
                return;
            }

            let moveId = this.datatable.data[event.dragIndex]['id'];
            let beforeId = this.datatable.data[event.dropIndex]['id'];

            let indexId = this.competitorIds.indexOf(moveId);
            let indexBeforeId = this.competitorIds.indexOf(beforeId);
            this.moveArrayItem(this.competitorIds, indexId, indexBeforeId);
            this.loadLazyData();
        },
        moveArrayItem(arr, fromIndex, toIndex) {
            let element = arr[fromIndex];
            arr.splice(fromIndex, 1);
            arr.splice(toIndex, 0, element);
        },
    }
}
</script>

<style scoped>
.p-button-danger {
    color: red;
}
.VuePagination .VuePagination__pagination-item {
    list-style: none!important;
}
.font-12 {
    font-size: 12px;
}
</style>